import { firestore } from './firebase';

// Queue Collection (Jobs)
const QueueCollection = firestore.collection('_queue');

export const createJob = async (job) => QueueCollection.doc().set(job);
